import React from 'react';
import Navbar from '../Navbar/Navbar';
import Contact from '../Contact/Contact';
import Footer from '../Footer/Footer';

const ContactPage = () => {
  return (
    <div className='contact-page'>
      <Navbar />
      <Contact />
      <Footer />
    </div>
  );
};

export default ContactPage;
